import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './AgeСategories.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Pagination from 'components/UI/Pagination/Pagination'
import Loader from 'components/UI/Loader/Loader'
import RowAge from './RowAge/RowAge'
import AddAgeCategorieModal from './AddAgeСategorieModal/AddAgeСategorieModal'

const initPagination = {
  page: 1,
  limit: 10,
}

const AgeCategories = () => {
  const [ageСategories, setAgeСategories] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const fetchSkills = () => {
    superAxiosRequest({
      method: 'get',
      link: 'db/age',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setAgeСategories(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchSkills()
  }, [pagination])

  const onBeforeSubmitClient = (data) => {
    const { name, company, ...rest } = data
    return {
      ...rest,
      ...(name && { name: data.name }),
      ...(company && { company: data?.company?.id }),
    }
  }

  const addDiscipline = () => {
    const ms = {
      modalBodyComponent: () => <AddAgeCategorieModal />,
      button: 'Save',
      link: 'db/age',
      title: 'Add age group',
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchSkills()
      },
      valid: {
        name: 'required',
        from_age: 'required',
        to_age: 'required',
      },
    }

    asideModalStore.activity(ms, {})
  }

  const editDiscipline = (data) => {
    const ms = {
      modalBodyComponent: () => <AddAgeCategorieModal />,
      button: 'Save',
      link: `db/age/${data?.id}`,
      title: 'Edit age group',
      isResponsive: true,
      is_put: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: (data) => {
        setAgeСategories((prev) => {
          return {
            ...prev,
            result: prev.result.map((age) =>
              age.id === data.id ? { ...age, ...data } : age,
            ),
          }
        })
      },
      valid: {
        name: 'required',
        from_age: 'required',
        to_age: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteDiscipline = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the age group?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `db/age/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setAgeСategories((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editDiscipline(items)],
      ['delete', () => deleteDiscipline(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={'Age categories'}>
          <HeaderAddButton title={'Add age'} onClick={addDiscipline} />
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            Records: {ageСategories?._meta?.count_items}
          </div>
          <div>
            {ageСategories?.result?.map((age, index) => (
              <RowAge key={age.id} age={age} index={index} action={action} />
            ))}
          </div>
        </div>
      )}
      <div className={st.pagination}>
        {ageСategories?._meta.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={ageСategories._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default AgeCategories
